<template>
  <div class="indexBox bg">
    <img class="WLJY_logo" v-if="matchId == 219 || matchId == 220 || matchId == 221 || matchId == 222 || matchId == 223"
      src="https://mc.posedu.com.cn/myAll_Img/WLJY_logo.png" style="left: 4.375rem;top: 3.75rem;" />
      <img  :src="hostUrl" alt="" style="height: 4.8rem;position: absolute;left: 2.5rem;top: 2rem;" v-if="hostUrl">
    <img  :src="technicalSupportUrl" alt="" style="height: 4.8rem;position: absolute;right: 2.5rem;top: 2rem;" v-if="hostUrl && technicalSupportUrl">
    <img  :src="technicalSupportUrl" alt="" style="height: 4.8rem;position: absolute;left: 2.5rem;top: 2rem;" v-if="!hostUrl && technicalSupportUrl">

      <div class="bigTitleBack bg">
      <div class="bigTitle">{{rankingStatus==0?'选手成绩':'选手排名'}}</div>
    </div>
    <!-- 选手信息 -->
    <div class="tableBox">
      <div class="tableBox_title">
        <div class="myTh myThOne" style="font-size: 2rem;">{{rankingStatus==0?'出场顺序':(matchId == 304 || matchId == 305 || matchId == 306 || matchId == 307 || matchId == 308?'当前排名':'序号') }}</div>
        <div class="myTh myThTwo" style="font-size: 2rem;">
          {{ '选手姓名' }}
        </div>
        <div class="myTh myThThree">
          {{ currentShowSchoolInfo == 1 ? '学校名称' : '专业'}}</div>
        <div class="myTh myThFour" style="font-size: 2rem;">分数</div>
      </div>
      <div class="tableBox_main" v-for="(item, index) in gradeRankWithSplit" :key="index">
        <div class="myTh myThOne">{{ rankingStatus==0?item.sort:index+1+(currPage-1)*10 }}</div>
        <div class="myTh myThTwo">
          <span>{{ item.name }}</span>
        </div>
        <div class="myTh myThThree">
          <span>{{ currentShowSchoolInfo == 1 ? item.schoolName : item.collegeName }}</span>
        </div>
        <div class="myTh myThFour">{{ item.scoreTotal }}</div>
      </div>
    </div>
    <div class="bottomBox">
      <img class="Decoration" src="https://mc.posedu.com.cn/myAll_Img/bot_left_Decoration.png" />
      <img class="Decoration" src="https://mc.posedu.com.cn/myAll_Img/bot_right_Decoration.png" />
    </div>
  </div>

</template>
<script>
export default {
  data() {
    return {
      gradeRankWithSplit: '', //选手排行列表
      pagesArr: ['/pages/index', '/pages/playerQuestions', '/pages/scoring', '/pages/playerRanking',
        '/pages/countdown', '/pages/totalScore_player'
      ], //首页banner、选题、打分、排行、倒计时、总分
      matchId: '',
      data_acquisitionTime: null,
      rankingStatus:0,  //0：按出场顺序排序   1：按选手成绩排序
      currentShowSchoolInfo:0,  //0:显示学院  1:显示学校
      collegeORschool: [],
      myPages: 1,
      carouselTime: 0,
      carouselNum: 0,
      totalPage: 1,
      currPage:1, //当前第几页
      hostUrl: '',
      technicalSupportUrl: '',
          hostUrl:'',
        technicalSupportUrl:''
    };
  },
  mounted() {
    this.matchId = this.$route.query.matchId;
    this.$post("grade_college_list", {}, {
      matchId: this.matchId,
    }).then((res) => {
      this.collegeORschool = res.data
    })
      .catch((err) => { });
    this.data_acquisition()
    this.hostUrl = sessionStorage.getItem('hostUrl')
    this.technicalSupportUrl = sessionStorage.getItem('technicalSupportUrl')
  },
  destroyed() {
    //console.log("销毁");
    let that = this
    // 销毁enter事件
    window.clearTimeout(that.data_acquisitionTime)
  },
  methods: {
    gradeRankWithSplitFun() {
      let that = this
      this.$post("gradeRankWithSplit", {
        matchId: this.matchId,
        page: this.myPages,
      }).then((res) => {
        console.log(res.data);
        this.currPage = res.data.currPage
        this.gradeRankWithSplit = res.data.list
        this.totalPage = res.data.totalPage
      })
        .catch((err) => { });
    },
    data_acquisition() {
      let that = this
      this.$get("gerSecondConsoleInfo", '?trackId=' + 1, {
        matchId: this.matchId,
      }).then((res) => {
        sessionStorage.setItem('screenModal', res.data.currentScreenModal?res.data.currentScreenModal:1)
        this.currentShowSchoolInfo = res.data.currentShowSchoolInfo
        if(res.data.currentScreenModal && res.data.currentScreenModal!=1){
              window.location.reload();
            }
            this.rankingStatus = res.data.rankingStatus
        this.carouselTime = res.data.carouselTime
        if(!res.data.carouselTime){
          this.carouselTime = 30
        }
        this.gradeRankWithSplitFun()
        this.data_acquisitionTime = window.setTimeout(() => {
          that.data_acquisition()
          that.carouselNum++
          if (that.carouselNum >= that.carouselTime) {
            if (that.totalPage > that.myPages) {
              that.myPages++
            } else {
              that.myPages = 1
            }
            that.carouselNum = 0
          }
        }, 1000);
      })
        .catch((err) => { });
    },
  }
}

</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
}

body {
  margin: 0;
  padding: 0;
}

.indexBox {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-image: url(https://mc.posedu.com.cn/myAll_Img/backOne.png);
  overflow: hidden;
}

.bigTitleBack {
  background-image: url(https://mc.posedu.com.cn/myAll_Img/bigTitle.png);
  font-size: 2.8125rem;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  width: 70.9375rem;
  height: 5rem;
  display: flex;
  justify-content: center;

}

.bigTitleBack .bigTitle {
  color: #4997FE;
  background-image: -webkit-linear-gradient(top, #79CBFB, #4997FE);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.tableBox {
  width: calc(100% - 8.75rem);
  margin-top: 2.7%;
  position: relative;
  z-index: 2;
}

.tableBox_title,
.tableBox_main {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  background: linear-gradient(180deg, rgba(14, 240, 235, 0.8) 0%, rgba(39, 114, 240, 0.8) 100%);
  color: #fff;
  font-size: 2.125rem;
  font-family: DIN Condensed-Bold, DIN Condensed;
  width: 100%;
  height: 5.3125rem;
  align-items: center;
  border-radius: 1.6875rem 1.6875rem 0 0;
}

.tableBox_main {
  color: #0E357A;
  font-size: 2.375rem;
  height: 7.5vh;
  max-height: 5rem;
  border-top: none;
  background: rgb(255, 255, 255, 0.8);
  border-radius: 0 0 0 0;
}

.myTh {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 0.1875rem solid rgba(255, 255, 255, 0.5);
}

.tableBox_main {
  border-bottom: 0.1875rem solid rgba(255, 255, 255, 0.5);
}

.myTh span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 0.625rem;
}

.myTh:nth-child(4n) {
  border-right: none;
}

/* .tableBox_main .myTh:nth-child(4n),
  .tableBox_main .myTh:nth-child(4n-3) {

  }

  .tableBox_main .myTh:nth-child(4n-1) {

  }

  .tableBox_main .myTh:nth-child(4n-2) {

  } */

.tableBox_main:last-child {
  border-bottom: none;
  border-radius: 0 0 1.6875rem 1.6875rem;
}

.myThOne {
  width: 13%;
  font-size: 3.75rem;
}

.myThTwo {
  width: 17%;
  font-size: 2.625rem;
}

.myThThree {
  width: 39%;
  font-size: 2rem;
}

.myThFour {
  width: 30%;
  font-size: 3.75rem;
}

.bottomBox {
  margin-top: 1.25rem;
  width: calc(100% - 15.625rem);
  position: absolute;
  bottom: 5vh;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/pages/playerRankingSplit.vue